import React from "react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";

export function OpcoesFamilia(props) {
    const {
        familias,
        escolhaFamilia,
        handleChangeFamilias,
        isSelectFamiliasDisabled,
    } = props;
    
    return (
        <Grid container>
            <Grid item xs={6}>
                <FormControl fullWidth>
                    <InputLabel id="label-familias">Familias</InputLabel>
                    <Select
                        autoWidth={false}
                        labelId="label-familias"
                        id="select-familias"
                        label="Familias"
                        value={escolhaFamilia}
                        onChange={handleChangeFamilias}
                        disabled={isSelectFamiliasDisabled}
                    >
                        {familias.map((familia, index) => (
                            <MenuItem
                                key={index}
                                value={familia.cd_familia}
                            >
                                {familia.nm_familia}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
}
